// extracted by mini-css-extract-plugin
export default {"list":"list_list__PyqIw","item":"list_item__NBZez","empty":"list_empty__JjMvi","empty__icon":"list_empty__icon__V1kdv"};